 <template>
    <MainContentSearchable title="Listado de puertas" id="puertas" v-model="filters" :meta="loading ? {} : puertas.meta" @updated="getPuertas">
        <template v-slot:header>
            <h3 class="card-title"></h3>
            <div class="card-tools">
                <Button class="m-1" @click="showModal('add-puerta')">CREAR PUERTA</Button>
                <CrearPuertaModal :evento_id="evento_id" @close="closeModal"></CrearPuertaModal>
            </div>
        </template>

        <template v-slot:content v-if="!loading && puertas">
            <div class="table-responsive has-options">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th class="text-center">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(puerta, index) in puertas.data">
                            <tr :key="index">
                                <td>{{ puerta.nombre }}</td>
                                <td class="text-center">
                                    <OpcionesDropdownComponent v-bind:options="[
                                        { type: 'action', action:() => showModal('editar-' + puerta.id), label: 'Editar'},
                                        { type: 'action', action:() => showModal('borrar-' + puerta.id), label: 'Borrar'},
                                    ]"/>
                                </td>
                                <EditarPuertaModal :puerta="puerta" :evento_id="evento_id" v-on:close="closeModal"></EditarPuertaModal>
                                <DeletePuertaModal :puerta_id="puerta.id" :evento_id="evento_id" @close="closeModal"></DeletePuertaModal>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </template>
    </MainContentSearchable>

</template>

<script>
import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent';
import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
import CrearPuertaModal from "./modals/CrearPuertaModal";
import DeletePuertaModal from './modals/DeletePuertaModal';
import EditarPuertaModal from './modals/EditarPuertaModal';

export default {
    props: ['evento_id'],
    data() {
        return {
            puertas: [],
            filters: {
                per_page: 10,
                page: 1,
                search: '',
                evento_id: this.evento_id
            },
            fields: [ 
                { key: 'time_lapse', label: 'Lapso de tiempo'},
                'email', 
                { key: 'id', label: 'opciones', class: 'text-center' }
            ],
            loading: true
        }
    },
    created() {
        this.getPuertas();
    },
    methods: {
        getPuertas : function() {
            const params = {
                filters : this.filters,
                evento_id: this.evento_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.puertas.index'), params).then(res => {
                this.puertas = res.data;
                this.loading = false;
            });
        },
        setPage(page) {
            this.filters.page = page;
            this.getPuertas();
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal, edited) {
            this.$modal.hide(modal);
            if(edited) {
                this.getPuertas();
            }
        },
    },
    components: {
        OpcionesDropdownComponent, MainContentSearchable, CrearPuertaModal, DeletePuertaModal, EditarPuertaModal
    }
}
</script>
